const s = (s, t, e) => {
  if (t) {
    const o = JSON.stringify(s);
    t.postMessage(o, e);
  }
};
export { s as default };
